import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const texts = {
  ca: {
    infoTitle: 'INFORMACIÓ BÀSICA SOBRE EL TRACTAMENT DE DADES PERSONALS:',
    responsable: 'Responsable del tractament de dades:',
    responsableValue: 'UGOLF IBERIA, S.L. (gestora del camp) i ARAVELL GOLF CLUB, S.L.U. (titular del camp).',
    finalitat: 'Finalitat del tractament:',
    finalitatValue: 'mantenir el contacte i la comunicació amb vostè i gestionar les peticions online realitzades.',
    drets: 'Drets:',
    dretsValue: 'Pot, quan escaigui, accedir, rectificar, suprimir, oposar-se, demanar la portabilitat de les dades, limitar el tractament, i no ser objecte de decisions només automatitzades, com indica la nostra',
    privacyLink: 'política de privacitat',
    privacyLabel: 'He llegit i accepto la política de privacitat',
    marketingLabel: "Autoritzo l'enviament de comunicacions electròniques de les activitats i serveis d'UGOLF IBERIA, S.L.",
    revoke: 'Pot revocar aquesta autorització en qualsevol moment enviant un e-mail en aquest sentit a datos@ugolf.eu o a secretaria@aravellgolfclub.com; també les comunicacions que li enviem inclouran, en la pròpia comunicació, l\'opció de deixar de rebre-les.'
  },
  es: {
    infoTitle: 'INFORMACIÓN BÁSICA SOBRE TRATAMIENTO DE DATOS PERSONALES:',
    responsable: 'Responsable de tratamiento de datos:',
    responsableValue: 'UGOLF IBERIA, S.L. (gestor del campo) y ARAVELL GOLF CLUB, S.L.U. (titular del campo).',
    finalitat: 'Finalidad del tratamiento:',
    finalitatValue: 'mantener el contacto y la comunicación con Ud. y gestionar las peticiones online realizadas.',
    drets: 'Derechos:',
    dretsValue: 'Puede, cuando proceda, acceder, rectificar, suprimir, oponerse, pedir la portabilidad de los datos, limitar el tratamiento, y no ser objeto de decisiones sólo automatizadas, como indica nuestra',
    privacyLink: 'política de privacidad',
    privacyLabel: 'He leído y acepto la política de privacidad',
    marketingLabel: 'Autorizo el envío de comunicaciones electrónicas de las actividades y servicios de UGOLF IBERIA, S.L.',
    revoke: 'Puede revocar dicha autorización en cualquier momento mandando un e-mail en ese sentido a datos@ugolf.eu o a secretaria@aravellgolfclub.com; también las comunicaciones que le enviemos incluirán, en la propia comunicación, la opción de dejar de recibirlas.'
  },
  fr: {
    infoTitle: 'INFORMATIONS DE BASE SUR LE TRAITEMENT DES DONNÉES PERSONNELLES :',
    responsable: 'Responsable du traitement des données :',
    responsableValue: 'UGOLF IBERIA, S.L. (gestionnaire du parcours) et ARAVELL GOLF CLUB, S.L.U. (propriétaire du parcours).',
    finalitat: 'Finalité du traitement :',
    finalitatValue: 'maintenir le contact et la communication avec vous et gérer les demandes en ligne effectuées.',
    drets: 'Droits :',
    dretsValue: "Vous pouvez, le cas échéant, accéder, rectifier, supprimer, vous opposer, demander la portabilité des données, limiter le traitement et ne pas faire l'objet de décisions uniquement automatisées, comme indiqué dans notre",
    privacyLink: 'politique de confidentialité',
    privacyLabel: "J'ai lu et j'accepte la politique de confidentialité",
    marketingLabel: "J'autorise l'envoi de communications électroniques sur les activités et services d'UGOLF IBERIA, S.L.",
    revoke: "Vous pouvez révoquer cette autorisation à tout moment en envoyant un e-mail en ce sens à datos@ugolf.eu ou à secretaria@aravellgolfclub.com ; les communications que nous vous enverrons incluront également, dans la communication elle-même, l'option de ne plus les recevoir."
  },
  en: {
    infoTitle: 'BASIC INFORMATION ON PERSONAL DATA PROCESSING:',
    responsable: 'Data controller:',
    responsableValue: 'UGOLF IBERIA, S.L. (course manager) and ARAVELL GOLF CLUB, S.L.U. (course owner).',
    finalitat: 'Purpose of processing:',
    finalitatValue: 'to maintain contact and communication with you and manage the online requests made.',
    drets: 'Rights:',
    dretsValue: 'You may, where applicable, access, rectify, delete, object, request data portability, restrict processing, and not be subject to solely automated decisions, as indicated in our',
    privacyLink: 'privacy policy',
    privacyLabel: 'I have read and accept the privacy policy',
    marketingLabel: 'I authorize the sending of electronic communications about the activities and services of UGOLF IBERIA, S.L.',
    revoke: 'You may revoke this authorization at any time by sending an e-mail to that effect to datos@ugolf.eu or secretaria@aravellgolfclub.com; the communications we send you will also include, within the communication itself, the option to stop receiving them.'
  }
};

export const GdprConsent = ({ privacy, onPrivacyChange, marketing = false, onMarketingChange, showMarketing = false, idPrefix = 'gdpr' }) => {
  const { language } = useLanguage();
  const t = texts[language] || texts.ca;

  return (
    <div className="space-y-3 border-t border-gray-200 pt-4" data-testid={`${idPrefix}-gdpr-block`}>
      <div className="text-xs text-[#777777] italic leading-relaxed space-y-1">
        <p className="font-semibold">{t.infoTitle}</p>
        <p><strong>{t.responsable}</strong> {t.responsableValue}</p>
        <p><strong>{t.finalitat}</strong> {t.finalitatValue}</p>
        <p>
          <strong>{t.drets}</strong> {t.dretsValue}{' '}
          <Link to="/legal/privacitat" target="_blank" className="text-[#1A4D2E] underline hover:no-underline">
            {t.privacyLink}
          </Link>.
        </p>
      </div>

      <label className="flex items-start gap-3 cursor-pointer select-none">
        <input
          type="checkbox"
          required
          checked={privacy}
          onChange={(e) => onPrivacyChange(e.target.checked)}
          className="mt-0.5 w-4 h-4 accent-[#1A4D2E] cursor-pointer shrink-0"
          data-testid={`${idPrefix}-privacy-checkbox`}
        />
        <span className="text-sm italic text-[#444444]">{t.privacyLabel} *</span>
      </label>

      {showMarketing && (
        <label className="flex items-start gap-3 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={marketing}
            onChange={(e) => onMarketingChange(e.target.checked)}
            className="mt-0.5 w-4 h-4 accent-[#1A4D2E] cursor-pointer shrink-0"
            data-testid={`${idPrefix}-marketing-checkbox`}
          />
          <span className="text-sm italic text-[#444444]">{t.marketingLabel}</span>
        </label>
      )}

      {showMarketing && (
        <p className="text-xs text-[#777777] italic leading-relaxed">{t.revoke}</p>
      )}
    </div>
  );
};

export default GdprConsent;
